// src/features/monetize/eligibility.ts

/**
 * Pure resolution of Monetize visibility (unit-tested per ADR-004);
 * useMonetizeEligibility is its only runtime caller. All three inputs must
 * allow: the build flag, media access (the surface sells media), and the
 * api's verdict for the SELECTED account (GET /v1/monetize/v1/status —
 * the interim operator allowlist, later the billing facts). An absent verdict
 * (not loaded, or an api predating the route) fails CLOSED: the surface is
 * never teased to an account that cannot use it. Visibility only — the api
 * refuses every /v1/monetize call for a non-enabled account (403).
 */
export function resolveMonetizeEligibility(inputs: {
  flagEnabled: boolean;
  mediaAccess: boolean;
  serverEnabled: boolean | undefined;
}): boolean {
  return inputs.flagEnabled && inputs.mediaAccess && (inputs.serverEnabled ?? false);
}
